// InteractiveChart with Recharts implementation
// Timestamp: 2025-12-25T10:10:00.000Z

import React from 'react';
import { withPerformanceMonitoring } from '../../utils/featureFlags';
import RechartsInteractiveChart from './RechartsInteractiveChart';

interface InteractiveChartProps {
  type: 'line' | 'bar' | 'doughnut' | 'radar' | 'scatter';
  title: string;
  height?: number;
  onPointClick?: (point: any, data: any) => void;
}



/**
 * Main InteractiveChart component - Recharts implementation
 * Uses React.lazy to avoid circular dependency issues in production bundles
 */
export const InteractiveChart: React.FC<InteractiveChartProps> = (props) => {
  // Map 'doughnut' to 'pie' for Recharts implementation support
  const chartProps = {
    ...props,
    type: (props.type === 'doughnut' ? 'pie' : props.type) as any
  };

  // Use performance monitoring for the entire component
  return withPerformanceMonitoring(
    'InteractiveChart_Render',
    () => <RechartsInteractiveChart {...chartProps} />
  );
};

export default InteractiveChart;